export default __webpack_public_path__ + "static/media/logo.68a76176.svg";